<template lang="pug">
.mb-10
  AppOnOffToggle(
    v-model="excludeWorkBreaks"
    :disabled="disabled"
  )
    | {{ defaultLabel }}
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ReportExcludeWorkBreaksToggle',
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(['organization']),
    excludeWorkBreaks: {
      get() {
        return this.$store.getters.excludeWorkBreaks;
      },
      set(newValue) {
        this.$store.dispatch('updateSearch', { exclude_work_breaks: !!newValue });
      },
    },
    defaultLabel() {
      return 'Exclude workbreaks';
    },
  },
};
</script>
